import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48f0114e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "settings-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Settings", -1))

import MainSidebar from "@/components/MainSidebar.vue";
import HeyButton from "@/components/HeyButton.vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

async function logout() {
  await axios.delete("/sessions/delete");
  store.dispatch("logout");
  router.push("/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(HeyButton, { onClick: logout }, {
        default: _withCtx(() => [
          _createTextVNode("Logout")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})